(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/picasso/assets/javascripts/picasso-image.js') >= 0) return;  svs.modules.push('/components/numbergames/picasso/assets/javascripts/picasso-image.js');

'use strict';

const _svs$numbergames$pica = svs.numbergames.picasso.setup,
  picassoInstance = _svs$numbergames$pica.picassoInstance,
  imagesFitWrapper = _svs$numbergames$pica.imagesFitWrapper,
  imagesSizes = _svs$numbergames$pica.imagesSizes,
  imagesLazyLoading = _svs$numbergames$pica.imagesLazyLoading,
  preferredWidths = _svs$numbergames$pica.preferredWidths,
  imagesDescription = _svs$numbergames$pica.imagesDescription,
  availableFormats = _svs$numbergames$pica.availableFormats,
  getImagesExtensions = _svs$numbergames$pica.getImagesExtensions,
  getAspectRatio = _svs$numbergames$pica.getAspectRatio;


const getImageOptions = (filename, imageType, title, altText, fitWrapper, loadingLazy, sizes) => {
  var _imagesDescription$im, _imagesDescription$im2, _getAspectRatio, _getAspectRatio2;
  const url = "/".concat(picassoInstance[imageType], "/{width}/{extension}/").concat(filename, ".").concat(getImagesExtensions(imageType)[1]);
  const noscriptUrl = "/".concat(picassoInstance[imageType], "/").concat(preferredWidths[imageType][0], "/").concat(getImagesExtensions(imageType)[1], "/").concat(filename, ".").concat(getImagesExtensions(imageType)[1]);
  return {
    altText: altText || ((_imagesDescription$im = imagesDescription[imageType]) === null || _imagesDescription$im === void 0 ? void 0 : _imagesDescription$im.altText),
    title: title || ((_imagesDescription$im2 = imagesDescription[imageType]) === null || _imagesDescription$im2 === void 0 ? void 0 : _imagesDescription$im2.title),
    fitWrapper: fitWrapper || imagesFitWrapper[imageType],
    loadingLazy: loadingLazy || imagesLazyLoading[imageType],
    originalImage: false,
    sizes: sizes || imagesSizes[imageType],
    url,
    noscriptUrl,
    availableWidths: preferredWidths[imageType],
    aspectRatio: {
      width: (_getAspectRatio = getAspectRatio(imageType)) === null || _getAspectRatio === void 0 ? void 0 : _getAspectRatio.width,
      height: (_getAspectRatio2 = getAspectRatio(imageType)) === null || _getAspectRatio2 === void 0 ? void 0 : _getAspectRatio2.height
    },
    availableFormats
  };
};
const exported = {
  getImageOptions
};
if (svs.isServer) {
  module.exports = exported;
} else {
  svs.numbergames.picasso.image = exported;
}

 })(window);